<template>
  <v-card :elevation="isMobile == true ? 0 : 3">
    <v-toolbar color="grey lighten-2">
      <v-icon class="mr-3">mdi-clock-time-two-outline</v-icon>

      <v-toolbar-title class="subtitle-1"
        >Histórico de pesquisa</v-toolbar-title
      >
    </v-toolbar>
    <v-card
      class="mx-auto overflow-y-auto"
      :height="resultsMobile ? height : (innerHeight - 300) / 2 + 'px'"
      flat
    >
      <list-historico-pesquisa
        @search="buscar"
        :listaHistorico="newList"
        :tipo="tipo"
      />
    </v-card>
  </v-card>
</template>
<script>
import ListHistoricoPesquisa from "./ListHistoricoPesquisa.vue";
export default {
  components: { ListHistoricoPesquisa },
  props: {
    listaHistorico: {},
    resultsMobile: { type: Boolean, default: false },
    isMobile: { type: Boolean, default: false },
    tipo: { type: String }
  },
  data() {
    return {
      attrs: null,
      innerHeight: window.innerHeight,
      height: window.innerHeight - 50 + "px",
      newList: this.listaHistorico
    };
  },
  watch: {
    listaHistorico: {
      handler() {
        this.newList = this.listaHistorico;
      }
    }
  },
  methods: {
    buscar(item) {
      item.historico = true;
      item.isMobile = this.isMobile;
      this.$emit("search", item);
    }
  }
};
</script>
